

document.addEventListener("DOMContentLoaded", function () {
  //Lightbox default options
  //https://fancyapps.com/fancybox/3/docs/#options
  
  Fancybox.bind('.lightbox[rel="gallery]', {
    on: {
      "Carousel.contentReady": function (instance, slide) {
        if (instance.current.type == "image") {
          slide.el.wrapInner("<div class='fancybox-image-wrap'></div>");
        }
        if (instance.group.length > 1) {
          slide.el
            .find(".fancybox-image-wrap")
            .append(
              '<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>' +
              svgArrowSizeLeft +
              '</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>' +
              svgArrowSizeRight +
              "</span></a>"
            );
        }
      }
    }
  });

  //backwards compatibility with custom lightboxes
  document.querySelectorAll('.lightbox[rel="gallery"]').forEach(function (element) {
    element.fancybox();
  });

  document.querySelectorAll(".toggle-filter").forEach(function (element) {
    element.addEventListener("click", toggleFilter);
    element.addEventListener("keydown", toggleFilter);
  });
  
  function toggleFilter(e) {
    if (e.type == "keydown" && e.keyCode != 13) return;
    var toggled = e.currentTarget.dataset.toggled;
    e.currentTarget.dataset.toggled = !toggled;
    e.currentTarget.setAttribute("data-toggled", !toggled);
    if (toggled) {
      document.querySelector(".collection-filter-sidebar").style.display = "none";
      document.querySelector(".collection-grid-content").style.width = "100%";  
      e.currentTarget.setAttribute("aria-pressed", true);
    } else {
      document.querySelector(".collection-filter-sidebar").style.display = "block";
      document.querySelector(".collection-grid-content").style.width = "80%";
      e.currentTarget.setAttribute("aria-pressed", false);
    }
  }

  const radioButtons = document.querySelectorAll(
    '.product-selection input[type="radio"]'
  );

  if (radioButtons.length) {
    radioButtons.forEach((radioButton) => {
      radioButton.addEventListener("keydown", (event) => {
        const key = event.key;

        if (key === "ArrowUp" || key === "ArrowDown") {
          event.preventDefault();

          const currentIndex = Array.from(radioButtons).indexOf(radioButton);
          let newIndex;

          if (key === "ArrowUp") {
            newIndex =
              currentIndex === 0 ? radioButtons.length - 1 : currentIndex - 1;
          } else {
            newIndex =
              currentIndex === radioButtons.length - 1 ? 0 : currentIndex + 1;
          }

          radioButtons[newIndex].focus();
        }
      });
    });
  }

  document.getElementById("readmorebtn").addEventListener("click", handleReadMore);
  document.getElementById("readmorebtn").addEventListener("touch", handleReadMore);

  function handleReadMore(event) {
    event.preventDefault();
    document.getElementById("readmore").style.display = "block";
    document.getElementById("readmorebtn").style.display = "none";
    document.getElementById("readlessbtn").style.display = "inline-block";
  }

  document.getElementById("readlessbtn").addEventListener("click", handleReadLess);
  document.getElementById("readlessbtn").addEventListener("touch", handleReadLess);

  function handleReadLess(event) {
    event.preventDefault();
    document.getElementById("readmore").style.display = "none";
    document.getElementById("readmorebtn").style.display = "inline-block";
    document.getElementById("readlessbtn").style.display = "none";
  }

  document.querySelectorAll("a").forEach(function (element) {
    if (element.getAttribute("href") == undefined) element.setAttribute("href", "#");
  });
  listenToVideoButtons();
});

window.listenToVideoButtons = function() {
  document.querySelectorAll("[data-video-trigger]").forEach(function (elem) {
    if(window.innerWidth > 820) {
      elem.addEventListener("click", actionVideoButtons);
      elem.addEventListener("keypress", actionVideoButtons);
    } 
    if(elem.classList.contains('hero-controls')){
      elem.addEventListener("click", actionVideoButtons);
      elem.addEventListener("keypress", actionVideoButtons);
    }
  });
}

function actionVideoButtons(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  const { currentTarget } = e;
  const videoElement = document.getElementById(
    currentTarget.dataset.videoTrigger
  );
  if (currentTarget.classList.contains("hero-controls")) {
    if (currentTarget.classList.contains("paused")) {
      videoElement.play();
      currentTarget.classList.remove("paused");
    } else {
      videoElement.pause();
      currentTarget.classList.add("paused");
    }
  } else {
    videoElement.play();
    videoElement.setAttribute("controls", "");
    currentTarget.style.display = "none";
    videoElement.addEventListener("pause", function (e) {
      videoElement.removeAttribute("controls");
      currentTarget.style.display = "block";
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("resize", homepageSlideShows);
  homepageSlideShows();
  addImageLabels();
  let sizeSelected = false;
  document.querySelectorAll(".variant-input").forEach(function (element) {
    element.addEventListener("click", handleVariantInput);
  });
  function handleVariantInput(e) {
    setTimeout(addImageLabels, 100);
    const optionName = e.currentTarget.getAttribute("data-option-name");
    const colorName = ["Color", "color", "Colour", "colour"];
    if (colorName.indexOf(optionName) <= -1) {
      sizeSelected = true;
    }
    if (sizeSelected !== true) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showSizePrompt(e.currentTarget);
    }
  }
  let pageContent = null;
  document.querySelectorAll("[data-ajax-content]").forEach(function (element) {
    element.addEventListener("click", handleAjaxContent);
  });
   async function handleAjaxContent(e) {
    const srcId = e.currentTarget.getAttribute("data-src");
    if (pageContent == null) {
      const ajaxContent = await fetch("/pages/about-woolx?view=ajax-content");
      const ajaxBody = await ajaxContent.text();
      const parser = new DOMParser();
      let pageContent = parser.parseFromString(ajaxBody, "text/html");
      Fancybox.open(
        pageContent
          .getElementById(srcId)
          .content.querySelector(".table-content")
      );
    } else {
      Fancybox.open(
        pageContent
          .getElementById(srcId)
          .content.querySelector(".table-content")
      );
    }
  }
  setTimeout(function () {
    const disabledButtons = document.querySelectorAll('[aria-disabled="true"]');
    disabledButtons.forEach(function (btn) {
      btn.setAttribute("tabindex", -1);
    });
  }, 1000);
});

function showSizePrompt(elem) {
  elem.querySelector(".error-tooltip").classList.add("show");
  elem.querySelector(".error-tooltip").setAttribute("role", "alert");
  setTimeout(function () {
    elem.querySelector(".error-tooltip").classList.remove("show");
    elem.querySelector(".error-tooltip").removeAttribute("role");
  }, 2500);
}

function addImageLabels() {
  const productGallery = document.querySelectorAll(".pwzrswiper-lazy");
  if (productGallery.length > 0) {
    document.querySelectorAll(".pwzrswiper-lazy").forEach((img) => {
      const parent = img.parentElement;
      const alt = img.alt;
      if (alt != undefined) {
        const splitAlt = alt.split("|");
        img.alt = splitAlt[0];
        if (splitAlt[1] != undefined) {
          const label = document.createElement("div");
          label.innerText = splitAlt[1];
          label.classList.add("model-info-label");
          parent.appendChild(label);
        }
      }
    });
  } else {
    setTimeout(addImageLabels, 100);
  }
}

let homepageCollectionFlickity,
  homepageProductFlickity,
  isFlickity = false;

const homepageSlideShows = function () {
  if (window.innerWidth <= 1025) {
    homepageCollectionFlickity = new Flickity('[data-flickity="mobile-only"]', {
      cellAlign: "center",
      pageDots: false,
      wrapAround: true,
    });
    isFlickity = true;
    homepageProductFlickity = new Flickity(
      '[data-flickity="mobile-only-collection"]',
      {
        cellAlign: "left",
        pageDots: false,
        wrapAround: false,
      }
    );
    isFlickity = true;
  } else {
    if (isFlickity) {
      homepageCollectionFlickity.destroy();
      homepageProductFlickity.destroy();
      isFlickity = false;
    }
  }
  // this closes the searhc menu when clicking outside the element
  document.body.addEventListener("click", handleBodyClick);
  function handleBodyClick(event) {
    if (
      !event.target.closest(".site-header__search-container.is-active") &&
      !event.target.classList.contains("site-header__search-container.is-active")
    ) {
      document.dispatchEvent(new Event("predictive-search:close"));
    }
  };
};

(function() {
  document.addEventListener('ajaxProduct:added', async function(e) {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelector('[data-cart-count]').dataset.cartCount = cart.item_count;
  });
  document.addEventListener('DOMContentLoaded', function () {
    const header = document.getElementById("SiteHeader");
    const headerHeight = header.offsetHeight;
     document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  })
})();